import { useEffect } from "react";

import i18n from "../../../../i18n";
import { setPatientTerm, setProfessionalTerm } from "../../../../shared/i18n/patientTerm";
import { usePortalRecords } from "../../application/usePortalAuth";

/**
 * Applies the active panel's vocabulary to the portal.
 *
 * A training centre teaches, so the person running the panel is a mentor and
 * the person reading it is a student — calling them a therapist and a patient
 * would describe a relationship the student is not in. Nothing behaves
 * differently; it is a matter of words, so nothing is branched and the same
 * post-processor that serves the therapist's own chosen term does this one.
 *
 * It follows the *active* record, not the account: somebody in therapy with
 * one professional and enrolled in a course with another reads each panel in
 * its own words, and switching changes them.
 *
 * The term travels as sent. One word serves the whole product: wherever the
 * person is a mentor, what they hold is a mentoría rather than a session.
 */
export default function PortalVocabulary() {
  const { activeRecord } = usePortalRecords();
  const patientTerm = activeRecord?.patient_term ?? null;
  const professionalTerm = activeRecord?.professional_term ?? null;

  useEffect(() => {
    setPatientTerm(patientTerm);
    setProfessionalTerm(professionalTerm);
    // The post-processor runs as strings are translated, so what is already on
    // screen has to be asked for again.
    i18n.changeLanguage(i18n.language);
  }, [patientTerm, professionalTerm]);

  return null;
}
